<!--
    校区管理-老师管理-上课统计
    功能：展示老师上课统计相关数据
    组件:AppList、AppSearch
-->
<template>
  <div class="teacher_statistics">
    <div class="total" v-if="info">
      <span>{{ info.teacher_info.name }}老师</span>
      <span>全部<b>{{ info.teaching_data.TOTAL }}</b></span>
      <span>未开始<b>{{ info.teaching_data.WAIT }}</b></span>
      <span>已结束<b>{{ info.teaching_data.END }}</b></span>
      <span>老师缺席<b>{{ info.teaching_data.LACK }}</b></span>
    </div>
    <AppList
      ref="list_live"
      :list.sync="list"
      title=""
      api="/api/liveroom"
      :api-type="api">
      <AppSearch
        slot="search"
        date-type="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="80px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-link
                v-if="$store.state.from === 'schoolCenter'"
                @click="StatisticalClass(scope.row)"
              >详情</el-link>
              <el-button
                v-else
                size="small"
                @click="StatisticalClass(scope.row)"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
  </div>
</template>

<script>
  import list from '@/mixins/list';
  import baseUrl from "../../utils/api";
  export default {
    name: "TeacherStatistics",
    mixins: [list],
    data() {
      return {
        id: this.$route.params.id,
        api: '',
        list: {},
        info: null,
        columns: [],
      }
    },
    computed: {
      searchArr() {
        const column = [
          { prop: 'name', label: '课题名称' },
          { prop: 'number', label: '教室编号' }
        ];
        return [
          {
            componentType: 'AppSearchDate',
            searchType: 'created_at',
          },
          {
            selectValue: [
              { value: 2, name: '直播中' },
              { value: 1, name: '未开始' },
              { value: 3, name: '已结束' },
              { value: 4, name: '老师缺席' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'status',
            placeholder: '请选择直播状态'
          },
          {
            selectValue: [
              { value: 1, name: '班级直播' },
              { value: 2, name: '链接直播' },
              { value: 3, name: '线下课' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'type',
            placeholder: '请选择直播类型'
          },
          {
            selectValue: [
              { value: 1, name: 'AI课件' },
              { value: 2, name: 'AI双师课件' },
              { value: 3, name: '互动课件' },
              { value: 4, name: '其他' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'course_type',
            placeholder: '请选择选课类型'
          },
          {
            selectValue: [
              { value: 1, name: '1v1' },
              { value: 2, name: '1v4' },
              { value: 3, name: '1v6' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'video_type',
            placeholder: '请选择授课班型'
          },
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
      role() {
        return this.$store.state.user;
      },
    },
    created() {
      this.columns = [
        {
          label: '直播时间',
          width: '180px',
          formatter: row => {
            let time = '';
            switch (row.status) {
              case 1: // 未开始 展示预设直播开始时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 2: // 直播中 展示实际直播开始时间~--
                time = `${row.begin_time} ~ --`;
                break;
              case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                time = `${row.begin_time} ~ ${row.close_time}`;
                break;
              case 4: // 缺课 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 5: // 已取消 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              default:
                break;
            }
            return time
          }
        },
        {
          label: '直播时长',
          formatter: row => {
            const time = this.$setting.setTime(row.act_liveroom_second);
            return `${time.hour}:${time.min}:${time.sec}`
          }
        },
        { prop: 'name', label: '课题' },
        { prop: 'number', label: '教室编号' },
        { prop: 'teacher.name', label: '授课老师' },
        {
          label: '直播类型',
          formatter: row => {
            const type = {
              1: '班级直播间',
              2: '链接直播间',
              3: '线下课'
            };
            return type[row.type]
          }
        },
        {
          label: '选课类型',
          formatter: row => {
            const type = {
              1: 'AI课件',
              2: 'AI双师课件',
              3: '互动课件',
              4: '其他',
              0: '其他'
            };
            return type[row.course_type]
          }
        },
        { prop: 'course_name', label: '课时名称' },
        // { prop: 'name99', label: '课件类型' },
        // { prop: 'name98', label: '课件名称' },
        {
          label: '直播状态',
          formatter: row => {
            const status = {
              1: '未开始',
              2: '直播中',
              3: '已结束',
              4: '缺课',
              5: '已取消'
            };
            return status[row.status]
          }
        },
        {
          label: '授课班型',
          formatter: row => {
            const type = {
              1: '1v1',
              2: '1v4',
              3: '1v6',
            };
            return type[row.video_type];
          }
        },
        { prop: 'student_count', label: '班级学生数' },
        { prop: 'student_count', label: '上课总人次' }
      ];
      this.api = `/api/liveroom?is_show_teacher=1&equal[teacher_id]=${this.id}&order[id]=desc`;
      this.$http.get(`/api/liveroom/data/teacher/${this.id}`)
        .then(res => {
          this.info = res.data;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    methods: {
      // 确认授权
      onSubmit() {
        console.log(1)
      },
      // 上课统计详情
      StatisticalClass(row) {
        localStorage.setItem('liveroom_action', JSON.stringify(row));
        this.$router.push(`/teacher/statistics/detail/${row.id}`)
      }
    }
  }
</script>

<style scoped lang="scss">
  .log {
    .total {
      text-align: right;
      font-size: 16px;
      color: var(--color-primary);
      span {
        margin: 0 10px;
        b {
          margin: 0 5px;
        }
      }
    }
  }
</style>
<style lang="scss">
  .teacher_statistics {
    .app-search-status {
      max-width: 140px;
      .el-select {
        max-width: 140px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Teacher/statistics.vue